import React from 'react'
import PropTypes from 'prop-types'

import { ContentHeader } from '../components/contentHeader/ContentHeader'

export const PageWrapper = ({ contentHeaderConfig, children }) => {
  return (
    <>
      <ContentHeader {...contentHeaderConfig} />
      <div id='maincontent'>
        <div className='wrapper'>{children}</div>
      </div>
    </>
  )
}

PageWrapper.propTypes = {
  contentHeaderConfig: PropTypes.object,
  children: PropTypes.node
}
